import BaseObject from '../../../../../base/base_object';
import {SYSTEM_EVENTS} from '../../../../../events/events';
import Event from '../../../../../utils/event';

class TouchIdBaseScreen extends BaseObject {
    /**
     * @static
     * @type {string}
     */

    _parent = null;

    _html = null;

    _setHtml(html) {
        this._html = html;
    }

    setParent(parent) {
       this._parent = parent;
       return this;
    }

    getEl() {
        return this._parent.getEl();
    }

    show() {
        let screen = this._parent.bake(this._html);
        this._parent.setHTML(screen);

        return this;
    }

    onInitScreenShow() {
        Event.fire(SYSTEM_EVENTS.TOUCH_ID_INIT_SCREEN_SHOW);
    }

    close() {
        this._parent.close();
    }


    onTryAgainSkip() {
        this.close();
    }

    onNativeCancel() {
        this.close();
    }

    /**
     * @override
     * @returns {Array}
     * @private
     */
    _getButtons() { return []; }

    onCheckTouchEnable(bChecked) {}
    closeScreen() {}
    onClosedByClicked() {}
    onComponentOpened() {}
}
export default TouchIdBaseScreen;
